export default "https://statics.cloudfastin.top/static/v1.27.34/store/images/Amazon.png?850a2898099c395dca5c9d90dd06c703";